<template>
    <div>
        <b-row class="mb-3">
            <b-col>
                <b-input-group size="sm">
                    <b-form-select class="mr-3" style="width: 10rem;" :options="genreList" v-model="filters.genre">
                        <template #first>
                            <b-form-select-option :value="null">Genre</b-form-select-option>
                        </template>
                    </b-form-select>

                    <b-form-select class="mr-3" :options="formatList" v-model="filters.format">
                        <template #first>
                            <b-form-select-option :value="null">Format</b-form-select-option>
                        </template>
                    </b-form-select>

                    <b-form-select v-model="sort" @change="getNextItem()" style="width: 7rem;">
                        <template #first>
                            <b-form-select-option :value="null">Sort</b-form-select-option>
                        </template>
                        <b-select-option value="priceAsc">Price Ascending</b-select-option>
                        <b-select-option value="priceDesc">Price Descending</b-select-option>
                        <b-select-option value="qtyDesc">Quantity Descending</b-select-option>
                    </b-form-select>
                </b-input-group>
            </b-col>

            <b-col align="right">
                <b-button @click="noMatch()" variant="outline-danger" size="sm" class="mr-3">
                    <b-icon-x></b-icon-x>
                    <span class="ml-2 mr-1">No Match</span>
                </b-button>

                <b-button @click="resetSkipped()" variant="outline-secondary" size="sm" class="mr-3" :disabled="skippedItems.length === 0">
                    <b-icon-arrow-clockwise></b-icon-arrow-clockwise>
                    <span class="ml-2 mr-1">Reset Skipped</span>
                </b-button>

                <b-button @click="skipItem()" variant="outline-secondary" size="sm">
                    <b-icon-arrow-right-circle></b-icon-arrow-right-circle>
                    <span class="ml-2 mr-1">Next</span>
                </b-button>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                    
                <b-spinner v-if="isLoading" />
                <item-overview v-else class="item-row p-3" :item="currentItem"></item-overview>
 
            </b-col>

            <b-col class="mr-3" style="height: 320px; max-height: 320px; overflow-y: scroll;">
                <div v-if="!hasReleases">
                    <b-spinner />
                </div>
                <div v-else-if="results.length > 0">
                    <div v-for="(item, index) in results" :key="index">
                        <b-row class="mb-3 p-3 item-row">
                            <b-col>
                                <images-zoom hasFullUrl="true" :images="prepareImages(item)" />

                                <div class="mt-3">
                                    <p class="mb-0">{{ item.country }}
                                    {{ getFormats(item.formats).join(',&nbsp;') }}</p>
                                    <p class="mb-0">{{ item.label[0] }} {{ item.catno }}</p>
                                </div>
                            </b-col>
                            <b-col>
                                <div class="mb-5">
                                    <b-button size="sm" variant="outline-info" @click="viewOnDiscogs(item.id)">
                                        <b-icon-box-arrow-up-right></b-icon-box-arrow-up-right>
                                        <span class="ml-2 mr-1">View on Discogs</span>
                                    </b-button>
                                </div>
                                <div>
                                    <b-button size="sm" variant="outline-success" @click="match(item)">
                                        <b-icon-check></b-icon-check>
                                        <span class="ml-2 mr-1">Match</span>
                                    </b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <div v-else>
                    No potential matches. Fetching next item.
                </div>
            </b-col>

            <!-- <div v-for="(item, index) in results" :key="index">
                    <pre>{{ item }}</pre>
                </div> -->
        </b-row>
    </div>
</template>

<script>
    import inventoryApi from "../../api/inventory.js";
    import ItemOverview from "../../components/inventory/ItemOverview";
    import discogsApi from "../../api/discogs.js";
    import ImagesZoom from "../../components/inventory/ImagesZoom.vue";
    import genreList from "../../assets/genreList";

    export default {
        name: "DiscogsMatching",
        mixins: [ inventoryApi, discogsApi, genreList ],
        components: { ItemOverview, ImagesZoom },
        data() {
            return {
                isLoading: false,
                currentItem: {},
                items: [],
                results: [],
                images: {},
                hasReleases: false,
                itemIndex: 0,
                filters: {
                    genre: null,
                    format: null,
                },
                formatList: [ '45', 'LP', '12', 'CD' ],
                sort: null,
                skippedItems: [],
            }
        },
        async mounted() {
            this.itemIndex = 0;
            this.getSkippedItems();
            this.getItem();
        },
        methods: {
            resetSkipped() {
                this.skippedItems.splice(0);

                localStorage.setItem('skippedItems', JSON.stringify(this.skippedItems));
            },
            getSkippedItems() {
                let skippedItems = localStorage.getItem('skippedItems') || '[]';
                this.skippedItems = JSON.parse(skippedItems);
            },
            setSkippedItem(itemId) {
                if (this.skippedItems.indexOf(itemId) === -1) {
                    this.skippedItems.push(itemId);
                }

                localStorage.setItem('skippedItems', JSON.stringify(this.skippedItems));
            },
            async noMatch() {
                await this.addNoMatch(this.currentItem.itemId);
                await this.getItem();
            },
            async getNextItem() {
                this.itemIndex += 1;
                await this.getItem();
            },
            skipItem() {
                this.setSkippedItem(this.currentItem.itemId);
                this.getNextItem();
            },
            async getItem() {
                this.isLoading = true;
                let query = {
                    noDiscogsId: true,
                    noDiscogsAttempts: true,
                    limit: 1,
                    skip: this.itemIndex,
                    skippedItems: this.skippedItems,
                    hasImages: true,
                    isActive: true,
                };

                for (let key in this.filters) {
                    if (this.filters[key]) {
                        query[key] = this.filters[key];
                    }
                }
                
                if (this.sort) {
                    if (this.sort === "priceAsc") {
                        query.sort = "price";
                        query.dir = "asc";
                    } else if (this.sort === "priceDesc") {
                        query.sort = "price";
                        query.dir = "desc";
                    } else if (this.sort === "qtyDesc") {
                        query.sort = "quantity";
                        query.dir = "desc";
                    }
                }

                const resp = await this.getItems(query);
                this.currentItem = resp.docs[0];
                this.isLoading = false;
            },
            getMatchFormat(media) {
                if (media.size === '12' && media.duration === 'LP') {
                    return 'LP Vinyl';
                } else if (media.size === '12' && media.duration === 'Single') {
                    return '12" Vinyl';
                }

                return '7" Vinyl';
            },
            async getPotentialMatches(item) {
                this.hasReleases = false;
                const params = {
                    type: 'release',
                    artist: item.release.artist.last,
                    title: item.release.titles[0],
                    label: item.release.label?.name || '',
                    format: this.getMatchFormat(item.release.media[0]),
                    // catno: item.release.label?.labelNo || '',
                };

                let results = await this.doSearch(params);

                for (let i = 0; i < results.length; i++) {
                    try {
                        const item = await this.getRelease(results[i].id);
                        
                        this.images[results[i].id] = item.images;
                    } catch {
                        console.log('could not load');
                    }
                }
                this.results = results;
                this.hasReleases = true;

                if (this.results.length === 0) {
                    await this.addNoMatch(this.currentItem.itemId);
                    setTimeout(this.getNextItem, 2000);
                }
            },
            getFormats(formats) {
                return formats.map(format => {
                    if (format.text && format.descriptions.indexOf(format.text) === -1) {
                        format.descriptions.push(format.text);
                    }

                    if (format.descriptions) {
                        return format.descriptions.map(d => {
                            if (d !== 'Vinyl' && d !== 'Album') {
                                return d;
                            }
                        }).filter(Boolean);
                    }
                }).filter(Boolean);
            },
            viewOnDiscogs(releaseId) {
                window.open(`https://www.discogs.com/release/${releaseId}`);
            },
            async match(item) {
                await this.addMatch(this.currentItem.itemId, item.id);
                await this.getNextItem();
            },
            prepareImages(item) {
                if (this.images[item.id]) {
                    return this.images[item.id].map(image => {
                        return { url: image.uri };
                    });
                }
            },
        },
        watch: {
            currentItem(item) {
                this.getPotentialMatches(item);
            },
            filters: {
                deep: true,
                handler() {
                    this.getNextItem();
                }
            },
        }
    }
</script>

<style scoped>
    .item-row {
        border: 1px solid rgb(222, 226, 230);
    }
</style>